import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { TableContainer, Table, TableBody, TableRow, TableCell } from "@mui/material";
import ReactPlayer from "react-player";
import { useEnumApi } from "contexts/EnumApiContext";
import { fromServerFormat } from "components/date_picker/dateUtils";
import { makeFaultsMessage } from "data/data";

const EquipmentAlertAndInspectionTable = ({equipmentAlert}) => {
  const { getEnumValueByEnumNameAndCode } = useEnumApi();
  const { t } = useTranslation();
  const [movie, setMovie] = useState(null);

  const playMovie = (diagnosisId) => {
    setMovie(window.RUNTIME_CONFIG.REACT_APP_API_URL+"/api/download/:direct?fileGroup=DCV&id="+diagnosisId);
  }

  const statusClassName = useMemo(()=> {
    switch(equipmentAlert.status){
      case "D":
        return "condition1";
      case "F":
        return "condition2";
      case "M":
        return "condition6";
      default:
        return "";
    }
  }, [equipmentAlert.status])


  const fllwActionTypeClassName = useMemo(()=> {
    switch(equipmentAlert.fllwActionType){
      case "O1_WAIT":
        return "condition1";
      case "O2_OBSERVE":
        return "condition2";
      case "O3_MNT":
        return "condition5";
      case "O4_NORMAL":
        return "condition6";
      default:
        return "";
    }
  }, [equipmentAlert.fllwActionType])

  return(
                <>
                  <TableContainer>
                    <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width" style={{borderCollapse:"unset", borderSpacing:"revert"}}>
                      <TableBody>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alertedAt')}</TableCell>
                          <TableCell align="center">
                            {t('message.common.text.first')} : {equipmentAlert.alertedAt && fromServerFormat(equipmentAlert.alertedAt, {format:t('message.common.text.date.format.datetime')})}
                            {equipmentAlert.latestAlertedAt && <><br/>{t('message.common.text.last')} : {fromServerFormat(equipmentAlert.latestAlertedAt, {format:t('message.common.text.date.format.datetime')})}</>}
                          </TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alertType')}</TableCell>
                          <TableCell align="center">{equipmentAlert.alertType && getEnumValueByEnumNameAndCode("AlertType", equipmentAlert.alertType)?.[0]?.title}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alertCategory')}</TableCell>
                          <TableCell align="center">{equipmentAlert.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", equipmentAlert.alertCategory)?.[0]?.title}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alertDetail')}</TableCell>
                          <TableCell className="pl" colSpan={3} style={{textAlign:"left",whiteSpace:"pre-line"}}>
                            <div style={{minHeight:"242px", display:"flex", flexDirection:"column", justifyContent:"center"}}>
                            {equipmentAlert.alertDtl ?? ''}{equipmentAlert.alertDtl && <br/>}
                            {equipmentAlert && makeFaultsMessage(equipmentAlert, getEnumValueByEnumNameAndCode, true, playMovie)}
                            </div> 
                          </TableCell>
                          <TableCell colSpan={2} align="center">
                            {movie && 
                            <div className='player-wrapper' style={{width:'100%'}}>
                              <ReactPlayer
                                className='react-player'
                                url={movie}
                                width='100%'
                                height='100%'
                                playing={true}
                                //muted={true}
                                loop={true}
                              />
                            </div>
                            }
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alert.checkedAt')}</TableCell>
                          <TableCell align="center">{equipmentAlert.chkedAt && fromServerFormat(equipmentAlert.chkedAt, {format:t('message.common.text.date.format.datetime')})}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alert.check.user')}</TableCell>
                          <TableCell align="center">{equipmentAlert.chkUser}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.status')}</TableCell>
                          <TableCell>
                            {equipmentAlert && equipmentAlert.status && <div className={statusClassName} >{getEnumValueByEnumNameAndCode("EquipmentAlertStatus", equipmentAlert.status)?.[0]?.title}</div>}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.constantInspection.checkedAt')}</TableCell>
                          <TableCell align="center">{equipmentAlert.fieldChkedAt && fromServerFormat(equipmentAlert.fieldChkedAt, {format:t('message.common.text.date.format.datetime')})}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.constantInspection.check.user')}</TableCell>
                          <TableCell align="center">{equipmentAlert.fieldChkUser}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.fllwActionType')}</TableCell>
                          <TableCell align="center">
                            {equipmentAlert && equipmentAlert.fllwActionType && <div className={fllwActionTypeClassName}>{getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)?.[0]?.title}</div>}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  
                </>
  )
}

export default EquipmentAlertAndInspectionTable;